import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from 'app/shared/apis/api.service';
import { of, switchMap, take } from 'rxjs';
import { DriverSimulationService } from 'app/services/driver-simulation.service';
import { isDriverUser } from '../driver-user';

export const DriverGuard: CanActivateFn = () => {
    const router = inject(Router);
    const driverSimulation = inject(DriverSimulationService);

    return ApiService.userCurrent.pipe(
        take(1),
        switchMap((user) => {
            if (isDriverUser(user)) {
                return of(true);
            }

            if (user?.is_admin) {
                return driverSimulation.getSimulatedUserId()
                    ? of(true)
                    : of(router.parseUrl('/module-entry'));
            }

            return of(router.parseUrl('/home'));
        }),
    );
};
